jQuery.feature_import("js-loginpage",
  () => require("./index.js"),
  mod => mod.feature_js_loginpage
);